<template>
  <div
    :class="[`uptos-banner-${stylesVariant}`]"
    @click="!sideDrawer && goToPool()"
  >
    <div :class="[`uptos-banner-${stylesVariant}__ellipse`]" />
    <div :class="[`uptos-banner-${stylesVariant}__background-gradient`]">
      <img
        alt="background"
        class="image-gradient"
        src="@/assets/banners/green-background.svg"
      />
    </div>
    <img
      :class="[`uptos-banner-${stylesVariant}__logo`]"
      alt="uptos-and-aptos-coin"
      src="@/assets/banners/uptos-banner.png"
    />
    <div :class="[`uptos-banner-${stylesVariant}__item`]">
      <img
        :class="[`uptos-${stylesVariant}`]"
        alt="uptos title"
        src="@/assets/banners/uptos-text.png"
      />
      <p :class="[`aptos-${stylesVariant}`]">{{ $t('swap.aptos') }}</p>
    </div>
    <div :class="[`uptos-banner-${stylesVariant}__item`]">
      <p v-if="!props.sideDrawer" class="available">
        {{ $t('swap.availableOnLiquidSwap') }}
      </p>
      <p-button
        v-if="props.sideDrawer"
        :class="[`uptos-banner-${stylesVariant}__action-button`]"
        @click="goToPool"
      >
        {{ $t('swap.goToSwap') }}
      </p-button>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useRouter } from 'vue-router';
import { computed, inject } from 'vue';
import { EMixpanelEventNames, EMixpanelProvideKeys } from '@/types/enums';
import { Track } from '@/types';

const props = defineProps({
  sideDrawer: {
    type: Boolean,
    default: false,
    required: false,
  },
});

const emits = defineEmits(['cancel']);

const router = useRouter();
const track = inject(EMixpanelProvideKeys.Track) as Track;

const goToPool = () => {
  router.push({
    name: 'swap',
    query: {
      from: '0x1::aptos_coin::AptosCoin',
      to: '0x4fbed3f8a3fd8a11081c8b6392152a8b0cb14d70d0414586f0c9b858fcd2d6a7::UPTOS::UPTOS',
      curve: 'unstable',
      version: '0.5',
      target: 'swap',
    },
  });
  track(
    props.sideDrawer
      ? EMixpanelEventNames.BannerUptos
      : EMixpanelEventNames.UptosMain,
  );
  onClose();
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const stylesVariant = computed(() => {
  return props.sideDrawer ? 'short' : 'full';
});

function onClose() {
  emits('cancel');
}
</script>

<style lang="scss" scoped>
.uptos-banner-full {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 84px;
  border-radius: 10px;
  background: #abaeff21;
  overflow: hidden;
  cursor: pointer;

  &__item {
    z-index: 2;
  }

  &__logo {
    margin-left: 30px;
    margin-right: 25px;
    z-index: 2;
    height: 100%;

    @media (max-width: 500px) {
      width: 80px;
      height: 84px;
      margin-left: 10px;
      margin-right: 10px;
    }
  }

  &__action-button {
    border: 1px solid #78e069;
    border-radius: 51px;
    padding: 5px 15px;
    background: #78e06938;
    font-family: Roboto, sans-serif;
    font-size: 13px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0;
    text-align: center;

    &:hover {
      border-color: #78e010;
      background: #78e06958;
    }

    @media (max-width: 500px) {
      font-size: 10px;
      margin-left: 5px;
    }

    @media (min-width: 500px) {
      margin-left: 13px;
    }
  }

  &__background-gradient {
    position: absolute;
    width: 100%;
    height: 84px;
  }

  &__ellipse {
    position: absolute;
    background: radial-gradient(
      46.65% 93.31% at 49.27% 106.09%,
      rgba(11, 178, 147, 0.29) 25.09%,
      rgba(55, 44, 123, 0.5) 76.41%,
      rgba(53, 42, 119, 0.3999) 81.13%,
      rgba(46, 37, 106, 0.2962) 86.02%,
      rgba(35, 28, 86, 0.1909) 90.99%,
      rgba(19, 15, 57, 0.0851) 95.99%,
      rgba(3, 3, 28, 0) 100%
    );
    transform: rotate(90deg);
    width: 100px;
    height: 50px;
    left: -30px;
    opacity: 0.7;
  }

  &__close-button {
    z-index: 3;
    position: absolute;
    top: 5px;
    right: 5px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 5px;
    color: rgba(#fff, 0.8);
  }
}

.uptos-banner-short {
  display: flex;
  position: relative;
  width: 100%;
  height: 51px;
  margin-bottom: 10px;
  align-items: center;
  border-radius: 10px;
  background: #abaeff21;
  overflow: hidden;
  gap: 15px;

  @media (max-width: 400px) {
    gap: 0;
  }

  &__item {
    z-index: 2;
    display: flex;
  }

  &__logo {
    margin-left: 30px;
    margin-right: 5px;
    z-index: 2;
    height: 100%;

    @media (max-width: 500px) {
      margin-left: 20px;
      margin-right: -2px;
    }
  }

  &__action-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: #78e06938;
    border: 1px solid #78e069;
    border-radius: 51px;
    padding: 5px 15px;
    font-family: Roboto, sans-serif;
    font-size: 13px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0;
    text-align: center;

    &:hover {
      border-color: #78e010;
      background: #78e06958;
    }

    @media (max-width: 500px) {
      font-size: 10px;
      padding: 6px;
    }
  }

  &__background-gradient {
    position: absolute;
    width: 100%;
    height: 51px;
    display: flex;
  }

  &__ellipse {
    background: radial-gradient(
      46.65% 93.31% at 49.27% 106.09%,
      rgba(11, 178, 147, 0.29) 25.09%,
      rgba(55, 44, 123, 0.5) 76.41%,
      rgba(53, 42, 119, 0.3999) 81.13%,
      rgba(46, 37, 106, 0.2962) 86.02%,
      rgba(35, 28, 86, 0.1909) 90.99%,
      rgba(19, 15, 57, 0.0851) 95.99%,
      rgba(3, 3, 28, 0) 100%
    );
    position: absolute;
    transform: rotate(90deg);
    width: 100px;
    height: 50px;
    left: -30px;
    opacity: 0.7;
  }
}

.uptos-full {
  width: 100px;
  @media (max-width: 500px) {
    width: 75px;
  }
}

.aptos-full {
  font-family: Work Sans, sans-serif;
  margin: -13px 12px 0 0;
  font-size: 32px;
  font-weight: 700;
  line-height: 35px;
  letter-spacing: 0;
  color: #ffffff;

  @media (max-width: 500px) {
    font-size: 22px;
  }
}

.uptos-short {
  width: 85px;
  @media (max-width: 500px) {
    margin-left: 10px;
    width: 75px;
  }
}

.aptos-short {
  font-family: Work Sans, sans-serif;
  display: flex;
  align-self: center;
  font-size: 22px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
  margin: 0 10px 0;
  color: #ffffff;

  @media (max-width: 500px) {
    font-size: 20px;
  }
}

.available {
  margin: 0 0 8px;
  font-family: Work Sans, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0;
  color: #ffffff;

  @media (min-width: 500px) {
    margin-left: 13px;
  }

  @media (max-width: 385px) {
    font-size: 12px;
  }

  @media (max-width: 500px) {
    margin-left: 5px;
  }
}

.image-gradient {
  width: 100%;
}
</style>
